import React, { useState, useEffect } from "react";
import graphQuery from "../../../../assets/images/graphQuery.svg";
import "../../../../assets/scss/vendor_scss/generic.scss";
import ChartTocDropdown from "./ChartTocDropdown";

export interface IColoumnsHeaderProps {
  title: string;
  subTitle?: string;
  isDownload?: string | boolean;
  isDropdown?: boolean;
  dropdownOptions?: any;
  dropdownValue?: string | number;
  setDropdownValue?: any;
  isMidleBorder?: boolean;
  disableMenu?: boolean;
  handleDownloadBtn?: () => void;
  hints?: string;
}
const ColoumnsHeader: React.FC<IColoumnsHeaderProps> = (props) => {
  const [showGraphQuery, setShowGraphQuery] = useState<boolean>(false);
  const [showSEBIRules, setShowSEBIRules] = useState<boolean>(false);

  const wrapperRef = React.useRef<HTMLDivElement>(null);

  const onChange = (val: string) => {
    props.setDropdownValue(val);
  };

  useEffect(() => {
    /**
     *if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !wrapperRef.current?.contains(event.target)) {
        setShowSEBIRules(false);
        setShowGraphQuery(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="col_head">
      <div className="col_left_head">
        <h4>{props.title}</h4>
        <img
          className="pointer"
          src={graphQuery}
          alt="graphQuery"
          onClick={() => setShowGraphQuery(true)}
        />
        <div
          className="graphQuery_box"
          id={showGraphQuery ? "show_modal" : "hide_modal"}
        >
          <div className="graphQuery" ref={wrapperRef}>
            <span>
              <p>Day wise Earning data for the specific time frame.</p>
            </span>
            <span>
              <i
                className="edel-icon-close"
                onClick={() => setShowGraphQuery(false)}
              ></i>
            </span>
          </div>
        </div>
      </div>
      {!props.disableMenu && (
        <div className="col_right_head">
          <div className="sebi-rules-container" ref={wrapperRef}>
            <p className="pointer" onClick={() => setShowSEBIRules(true)}>
              {props.subTitle && props.subTitle}
            </p>
            <div id={showSEBIRules ? "show_modal" : "hide_modal"}>
              <div className="sebi-rules">
                <div className="sebi-rules-header sebi-rules-flex">
                  <p>SEBI Rules /Penalty clause of OTR</p>
                  <span>
                    <i
                      className="edel-icon-close"
                      onClick={() => setShowSEBIRules(false)}
                    ></i>
                  </span>
                </div>
                <div className="sebi-rules-heading sebi-rules-flex">
                  <p>Daily Algo Orders to Trade Ratio</p>
                  <p>Charges</p>
                </div>
                <div className="sebi-rules-flex">
                  <p>Less then 50</p>
                  <p>Nill</p>
                </div>
                <div className="sebi-rules-flex">
                  <p>50 to Less then 250</p>
                  <p>2 paise</p>
                </div>
                <div className="sebi-rules-flex">
                  <p>250 to Less then 500</p>
                  <p>10 paise</p>
                </div>
                <div className="sebi-rules-flex">
                  <p>500 to Less then 1000</p>
                  <p>15 paise</p>
                </div>
                <div className="sebi-rules-flex">
                  <p>1000 to Less then 2000</p>
                  <p>20 paise</p>
                </div>
                <div className="sebi-rules-flex">
                  <p>2000 or more then 2000</p>
                  <p>25 paise</p>
                </div>
                <div className="sebi-rules-footer">
                  <p>
                    if the ratio is 2000 or more on three occasions in the
                    previous thirty trading days (on rolling basis), the
                    concerned member shall not be permitted to place any orders
                    for the first 15 minutes on the next trading day as a
                    cooling off action.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {props.isDownload && (
            <p className="pointer">
              <i
                onClick={props.handleDownloadBtn}
                className="edel-icon-download"
              ></i>
            </p>
          )}

          {props.isMidleBorder && <i className="midleBorder"></i>}
          {props.hints && <span className="hints_text">{props.hints}</span>}
          {props.isDropdown && (
            <ChartTocDropdown
              selectedValue={
                props.dropdownValue
                  ? props.dropdownValue
                  : props.dropdownOptions[0].display
              }
              dropdownOptions={props.dropdownOptions}
              onSelect={(val: any) => {
                onChange(val);
              }}
              isSearchable={false}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ColoumnsHeader;
